<div class="p-8 min-h-dvh mb-20">
  <div
    *ngIf="!isLoading && packages.length > 0"
    class="text-center mb-14 mt-10"
  >
    <h2 class="text-4xl font-extrabold text-gray-900">
      Explora nuestros planes
    </h2>
    <p class="text-gray-600 mt-3 text-lg max-w-2xl mx-auto">
      Gestiona tus compañías, publica tus ofertas de empleo y potencia tu
      presencia con el plan que mejor se adapte a ti.
    </p>
  </div>
  <app-loading [text]="'Cargando paquetes'" *ngIf="isLoading"></app-loading>
  <div *ngIf="!isLoading && packages?.length === 0" class="text-center py-16">
    <h3 class="text-2xl font-bold text-primary mb-4">
      ¡Muy pronto nuevos paquetes exclusivos!
    </h3>
    <p class="text-gray-600 max-w-md mx-auto">
      Estamos preparando planes diseñados para que tu empresa brille más que
      nunca.
    </p>
  </div>
  <div
    *ngIf="!isLoading && packages.length > 0"
    class="flex p-2 gap-6 overflow-x-auto snap-x snap-mandatory pb-6 px-2 sm:px-4 md:px-8 lg:grid lg:grid-cols-4 lg:gap-8 lg:overflow-visible lg:px-0"
  >
    <div
      *ngFor="let pkg of packages"
      class="bg-white rounded border border-gray-200 shadow-md p-6 sm:p-8 transform transition duration-300 hover:scale-105 hover:bg-primary hover:border-primary flex-shrink-0 w-72 sm:w-80 snap-start md:w-[22rem] lg:w-auto group"
    >
      <div class="flex items-center mb-6">
        <div
          class="bg-primary/10 text-primary rounded-lg p-3 mr-4 transition-colors duration-300 group-hover:bg-white group-hover:text-primary"
        >
          <ng-icon name="featherBox" size="28"></ng-icon>
        </div>
        <h3
          class="text-xl font-bold text-gray-800 transition-colors duration-300 group-hover:text-white"
        >
          {{ pkg.name }}
        </h3>
      </div>
      <div class="mb-6">
        <span
          class="text-3xl font-bold text-primary transition-colors duration-300 group-hover:text-white"
        >
          {{ pkg.price | solesCurrency }}
        </span>
        <span
          class="text-gray-500 text-sm ml-1 transition-colors duration-300 group-hover:text-gray-200"
          >/anual</span
        >
      </div>
      <div class="space-y-3 mb-8">
        <div class="flex items-center gap-3 border-b border-gray-100 pb-2">
          <span
            class="text-sm font-semibold text-gray-800 transition-colors duration-300 group-hover:text-white"
          >
            Número de publicaciones anuales :
            <span class="text-primary group-hover:text-white">{{
              pkg.postMontQuantity
            }}</span>
          </span>
        </div>
        <div class="flex items-center gap-3 border-b border-gray-100 pb-2">
          <span
            class="text-sm font-semibold text-gray-800 transition-colors duration-300 group-hover:text-white"
          >
            Días en banner superior :
            <span class="text-primary group-hover:text-white">{{
              pkg.daysQuantityNoticeHome
            }}</span>
          </span>
        </div>
        <div class="space-y-3 mb-8">
          <div
            class="flex items-center gap-3 border-b border-gray-100 pb-2"
            *ngFor="
              let feature of [
                {
                  label: 'Acceso directo a CV',
                  value: pkg.fileAccessMonthQuantity
                },
                { label: 'Banner marca', value: pkg.bannerBrand },
                {
                  label: 'IGV incluido',
                  value: pkg.igv
                },
                {
                  label: 'Notificación por correo',
                  value: pkg.postulantEmailSendQuantity
                },
                { label: 'Portal web', value: pkg.webPortal },
                { label: 'Capacitación uso de codijobs', value: pkg.training },
                { label: 'Banner publicidad', value: pkg.bannerSponsor },
                {
                  label: 'Aparición en ofertas destacadas',
                  value: pkg.featuredJobOffer
                }
              ]
            "
          >
            <div
              class="flex items-center justify-center w-6 h-6 rounded transition-colors duration-300 text-primary group-hover:text-white"
              *ngIf="feature.value == '1'; else notIncluded"
            >
              <ng-icon name="featherCheck" size="20"></ng-icon>
            </div>
            <ng-template #notIncluded>
              <div
                class="flex items-center justify-center w-6 h-6 rounded transition-colors duration-300 text-red-500 group-hover:text-gray-200"
              >
                <ng-icon name="featherX" size="20"></ng-icon>
              </div>
            </ng-template>
            <span
              class="text-sm transition-colors duration-300"
              [ngClass]="{
                'text-gray-800 group-hover:text-white': feature.value == '1',
                'text-gray-500 group-hover:text-gray-200': feature.value == '0'
              }"
            >
              {{ feature.label }}
            </span>
          </div>
        </div>
      </div>
      <div class="text-center">
        <button
          (click)="openModal(pkg.idPackage)"
          class="bg-primary hover:bg-white hover:text-primary text-white px-6 py-2 rounded-lg font-semibold transition duration-300 group-hover:bg-white group-hover:text-primary"
        >
          Obtenerlo
        </button>
      </div>
    </div>
  </div>
  <div
    *ngIf="!isLoading && packages.length > 0"
    class="mt-20 overflow-x-auto hidden lg:block"
  >
    <h3 class="text-3xl font-bold text-center text-gray-900 mb-8">
      Compara nuestros planes
    </h3>
    <div
      class="min-w-max md:min-w-full border border-gray-200 rounded-xl overflow-hidden shadow-sm"
    >
      <table class="min-w-full text-xs sm:text-sm text-center border-collapse">
        <thead class="bg-primary text-white">
          <tr>
            <th class="py-4 px-6 text-left bg-white text-primary font-semibold">
              Características
            </th>
            <th
              *ngFor="let pkg of packages"
              class="py-4 px-6 font-semibold uppercase"
            >
              {{ pkg.name }}
            </th>
          </tr>
        </thead>
        <tbody class="bg-white">
          <tr class="border-b border-gray-100 hover:bg-gray-50 transition">
            <td class="py-3 px-6 text-left font-medium text-gray-800">
              Precio anual
            </td>
            <td
              *ngFor="let pkg of packages"
              class="py-3 px-6 text-primary font-semibold"
            >
              {{ pkg.price | solesCurrency }}
            </td>
          </tr>
          <tr class="border-b border-gray-100 hover:bg-gray-50 transition">
            <td class="py-3 px-6 text-left font-medium text-gray-800">
              Publicaciones anuales
            </td>
            <td *ngFor="let pkg of packages" class="py-3 px-6">
              {{ pkg.postMontQuantity }}
            </td>
          </tr>
          <tr class="border-b border-gray-100 hover:bg-gray-50 transition">
            <td class="py-3 px-6 text-left font-medium text-gray-800">
              Días en banner superior
            </td>
            <td *ngFor="let pkg of packages" class="py-3 px-6">
              {{ pkg.daysQuantityNoticeHome }}
            </td>
          </tr>
          <ng-container
            *ngFor="
              let feature of [
                {
                  label: 'Acceso directo a CV',
                  key: 'fileAccessMonthQuantity'
                },
                { label: 'Banner marca', key: 'bannerBrand' },
                {
                  label: 'IGV incluido',
                  key: 'igv'
                },
                {
                  label: 'Notificación por correo',
                  key: 'postulantEmailSendQuantity'
                },
                { label: 'Portal web', key: 'webPortal' },
                { label: 'Capacitación uso de Codijobs', key: 'training' },
                { label: 'Banner publicidad', key: 'bannerSponsor' },
                {
                  label: 'Aparición en ofertas destacadas',
                  key: 'featuredJobOffer'
                }
              ]
            "
          >
            <tr class="border-b border-gray-100 hover:bg-gray-50 transition">
              <td class="py-3 px-6 text-left font-medium text-gray-800">
                {{ feature.label }}
              </td>
              <td *ngFor="let pkg of packages" class="py-3 px-6">
                <div
                  *ngIf="
                    getFeatureValue(pkg, feature.key) == '1';
                    else notIncluded
                  "
                  class="flex justify-center items-center text-primary"
                >
                  <ng-icon name="featherCheck" size="20"></ng-icon>
                </div>
                <ng-template #notIncluded>
                  <div class="flex justify-center items-center text-red-500">
                    <ng-icon name="featherX" size="20"></ng-icon>
                  </div>
                </ng-template>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</div>
<div
  *ngIf="showModal"
  class="fixed inset-0 bg-black/60 flex items-center justify-center z-50"
>
  <div
    class="flex flex-col items-center justify-center bg-white p-8 rounded shadow-xl w-[95%] sm:w-[480px] relative min-h-[500px]"
  >
    <h3 class="text-2xl font-bold text-gray-900 mb-3 text-center">
      Adquirir paquete
    </h3>
    <p class="text-gray-600 text-center leading-relaxed mb-6">
      Selecciona la compañía con la que deseas adquirir este paquete.
    </p>
    <app-input-select
      label="Tus compañías"
      placeholder="Seleccione una compañía"
      [options]="companies"
      [control]="companyControl"
    ></app-input-select>
    <p class="text-gray-600 text-center leading-relaxed my-8">
      Estás a punto de realizar una solicitud para adquirir este paquete. Se
      enviará una petición a nuestros administradores para procesar tu solicitud
      y coordinar el proceso de pago. Una vez aprobada, podrás gestionar tus
      publicaciones desde tu panel empresarial. Si tienes alguna duda,
      contáctanos al
      <span class="font-semibold text-primary">+51 956 248 003</span>.
    </p>
    <div class="flex justify-center align-middle gap-3 mt-6">
      <button
        class="px-4 py-2 rounded bg-gray-200 text-gray-700 font-semibold hover:bg-gray-300 transition"
        (click)="closeModal()"
      >
        Cerrar
      </button>
      <app-loading-button
        [text]="'Confirmar'"
        [loading]="isLoadingPackage"
        (click)="acquirePackage()"
      ></app-loading-button>
    </div>
  </div>
</div>
